import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/learning.js";


const useStyles = makeStyles(styles);

export default function Learning() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={10} sm={10} md={10}>
            <GridContainer justify="center" >
             <GridItem xs={12} sm={12} md={12}>
                <a href='/Courses'>
                  <img
                    src={"/assets/images/firstpage_learning_banner.jpg"}
                    alt="جشنواره رویدادهای آموزشی"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
                {/*

              <GridItem xs={4} sm={3} md={2}>
              <a  href='/Courses/Section/All'>
                  <img
                    src={"/assets/images/courses.jpg"}
                    alt="دوره ها"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
              <GridItem xs={4} sm={3} md={2}>
                <a href='/Courses/Section/ScienceCommittee/'>
                  <img
                    src={"/assets/images/ScienceCommittee.jpg"}
                    alt="هیئت علمی"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
              <GridItem xs={4} sm={3} md={2}>
                <a href='/Courses/Section/DocumentInquiry/'>
                  <img
                    src={"/assets/images/Certificate.jpg"}
                    alt="گواهینامه"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
              <GridItem xs={4} sm={3} md={2}>
                <a  href='/ContactUs/'>
                  <img
                    src={"/assets/images/contactus.jpg"}
                    alt="ارتباط با ما"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>*/
              }

            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
